import { RootAPI } from "./index";
import session from "./session";

export default {
  decode: (token) => {
      return session.get(RootAPI + 'v2/byod/decode/' + token)
  },
};
